import { render } from "./SystemAdmin19.vue?vue&type=template&id=1cdbbcd0"
import script from "./SystemAdmin19.vue?vue&type=script&lang=js"
export * from "./SystemAdmin19.vue?vue&type=script&lang=js"

import "./SystemAdmin19.vue?vue&type=style&index=0&id=1cdbbcd0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__